if (!customElements.get('blog-nav')) {
  class BlogNav extends HTMLElement {
    constructor() {
      super();
      this.nav = this.querySelector('[data-nav-list]');

      if (!this.nav) return;

      this.preFade = this.querySelector('[data-nav-pre-fade]');
      this.nav?.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll() {
      if (this.nav.scrollLeft > 0) {
        if (this.preFade?.classList.contains('hidden')) this.preFade?.classList.remove('hidden');
      } else {
        if (!this.preFade?.classList.contains('hidden')) this.preFade?.classList.add('hidden');
      }
    }
  }

  window.BlogNav = BlogNav;

  customElements.define('blog-nav', BlogNav);
}
